import React, { Component } from 'react'

import './tags.scss'

class Tags extends Component {
	constructor(props) {
		super(props)
		this.state = {
			onClick: this.props.onClick ? this.props.onClick : this.removeEl
		}
	}

	removeEl = () => {
		console.log('You clicked close')
	}

	render() {
		let classes = ['vbui--tag', this.props.classes, this.props.state].join(' ')
		if (this.props.special) {
			return (
				<button className={classes} onClick={this.props.onClickTip}>
					{this.props.children}
					{this.props.showRemove && <span className="icon-icon-closing close-btn" onClick={this.state.onClick}></span>}
				</button>
			)
		} else {
			return (
				<div className={classes}>
					{this.props.children}
					{this.props.showRemove && <span className="icon-icon-closing close-btn" onClick={this.state.onClick}></span>}
				</div>
			)
		}
	}
}

export default Tags
